
<template>

<el-row>

    <el-row>

        <employee-select style="width:110px" @onEmployeeSelected="onCreatePeopleEmployeeSelected" @clear="onCreateClear" placeholder="创建人"></employee-select>

        <employee-select style="width:110px" @onEmployeeSelected="onEmployeeSelected" @clear="onClear" placeholder="收款人"></employee-select>

        <el-date-picker style="width:370px" v-model="form.createTime" type="datetimerange" start-placeholder="开始创建时间"  end-placeholder="结束创建时间" @change="onTimeChange">
        </el-date-picker>

        <el-date-picker style="width:370px" v-model="form.openingTime" type="datetimerange" start-placeholder="开始上架时间"  end-placeholder="结束上架时间" @change="onOpeningTimeChange">
        </el-date-picker>

        <el-input style="width:150px;" v-model="form.keyword" placeholder="商家名称/客户姓名/客户电话"></el-input>

        <el-button type="primary" @click="search()" >查询</el-button>
        <el-button type="danger" @click="$router.push('addReceivables')">新增收款</el-button>
    </el-row>
    <el-row style="margin-top:20px;">

        <el-table :data="datas" border style="width: 100%"     tooltip-effect="dark">
            <el-table-column label="编号"  >
                <template scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>

            <el-table-column label="商家信息" width="350px">
                <template scope="scope">
                    <span> {{ scope.row.customName }} - {{scope.row.customPhone}} （{{scope.row.companyName}}）</span>
                </template>
            </el-table-column>

            <el-table-column label="收款人">
                <template scope="scope">
                    <span>{{ scope.row.payeeName}}</span>
                </template>
            </el-table-column>

            <el-table-column label="上架时间">
                <template scope="scope">
                    <span>{{ scope.row.openingTime | dateFormat }}</span>
                </template>
            </el-table-column>

            <el-table-column label="有效期（月）">
                <template scope="scope">
                    <span>{{ scope.row.paymentCycle }}</span>
                </template>
            </el-table-column>

            <el-table-column label="税前收费（元）">
                <template scope="scope">
                    <span style="color:#F56C6C;font-weight:bold;"> {{ scope.row.paymentMoney }}</span>
                </template>
            </el-table-column>

            <el-table-column label="税后收费（元）">
                <template scope="scope">
                    <span style="color:#67C23A;font-weight:bold;"> {{ scope.row.afterTaxMoney }}</span>
                </template>
            </el-table-column>

            <el-table-column label="成本（元）">
                <template scope="scope">
                    <span style="color:#E6A23C;font-weight:bold;"> {{ scope.row.cost }}</span>
                </template>
            </el-table-column>

            <el-table-column label="创建人" prop="note" width="180px">
              <template scope="scope">
                  <span>{{scope.row.createPeople}} -  {{scope.row.createTime | dateFormat}}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作 ">
                <template scope="scope">
                  <el-button type="text"  @click="$router.push({name:'保存收款',params: { id: scope.row.id }})" >编辑</el-button>
                  <el-button type="text" v-confirm confirm-text="确认删除该记录" requestUrl="lcwpReceiptRecord/delLcwpReceiptRecord.action" :confirm-data="{id:scope.row.id}" @onConfirm="loadList">删除</el-button>
                  <!-- <el-button type="text" :style="{color:scope.row.status==1?'#f56c6c':'#67c23a'}" v-confirm :confirm-text="scope.row.status==1?'确认下架该商家？':'确认上架该商家？'" requestUrl="lcwpbusiness/changeBusinessStatus.action" :confirm-data="{id:scope.row.id,status:scope.row.status==1?2:1}" @onConfirm="$refs['list-template'].search()">{{data.status==1?'下架商家':'上架商家'}}</el-button> -->
                  <!-- <el-button type="text" @click="$router.push({name:'修改plus商家', params: { id: scope.row.id }})">修改商家</el-button> -->
                </template>
            </el-table-column>

        </el-table>
        <el-pagination style="margin-left:0px" class="row basic-margin" @size-change="fn" @current-change="fn" :current-page="currentPage" :page-size="20" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </el-row>
</el-row>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'
import EmployeeSelect from '@/components/EmployeeSelect'
export default {
  name: 'join-free',
  extends: BasicPager,
  data: function () {
    return {
      datas: [],
      form: {
        payStatus: null,
        goodType: null,
        keyword: null,
        createPeople: null
      },
      currentPage: 1,
      total: 0,
      loading: false
    }
  },
  components: {
    EmployeeSelect
  },
  created: function () {
    this.loadList(1)
  },
  filters: {},
  methods: {
    search: function () {
      this.currentPage = 1
      this.loadList()
    },
    onCreateClear: function () {
      this.form.createPeople = null
      this.loadList()
    },
    onClear: function () {
      this.form.payeeName = null
      this.loadList()
    },
    onCreatePeopleEmployeeSelected: function (item) {
      this.form.createPeople = item.text
      this.loadList()
    },
    onEmployeeSelected: function (item) {
      this.form.payeeName = item.text
      this.form.payeeId = item.id
      this.loadList()
    },
    onOpeningTimeChange: function (newValue) {
      if (newValue && newValue[0] && newValue[1]) {
        this.form.openStartTime = newValue[0].getTime()
        this.form.openEndTime = newValue[1].getTime()
      } else {
        this.form.openStartTime = null
        this.form.openEndTime = null
      }
      this.loadList()
    },
    onTimeChange: function (newValue) {
      if (newValue && newValue[0] && newValue[1]) {
        this.form.startTime = newValue[0].getTime()
        this.form.endTime = newValue[1].getTime()
      } else {
        this.form.startTime = null
        this.form.endTime = null
      }
      this.loadList()
    },
    fn: function (d) {
      this.currentPage = d
      this.loadList()
    },
    loadList: function () {
      let _this = this

      let param = {
        pageNum: this.currentPage,
        pageSize: 20,
        keyword: this.form.keyword,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        openStartTime: this.form.openStartTime,
        openEndTime: this.form.openEndTime,
        payeeName: this.form.payeeName
      }

      if (this.form.createPeople) {
        param.createPeople = this.form.createPeople
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
          _this.loading = false
        }
      }
      BasicModel.get(_this, 'lcwpReceiptRecord/findLcwpReceiptRecordList.action', param, listener)
    }
  }
}

</script>
